import React from 'react';

export enum CardItemType {
  diagnose = 'diagnose', // 诊断
  info = 'info',
  progress = 'progress',
  income = 'income',
  rights = 'rights',
}

export const CardItemTypeList = [
  { title: '广告诊断', type: CardItemType.diagnose },
  {
    title: <div className="task-rights-title">
      <span>任务权益</span>
      <span className="task-rights-label">激励任务</span>
    </div>,
    type: CardItemType.rights,
  },
  { title: '任务描述', type: CardItemType.info },
  { title: '任务动作', type: CardItemType.progress },
  { title: '任务收益', type: CardItemType.income },
];

export const TaskInfoList = [
  { name: 'date', label: '任务周期' },
  { name: 'task_type_name', label: '任务分类' },
  { name: 'content', label: '任务描述' },
];

// 任务时间状态
export enum TaskTimeStatus {
  future = 0,
  now = 10,
  past = 20,
}

export const TaskTimeStatusName = {
  [TaskTimeStatus.future]: '预告期',
  [TaskTimeStatus.now]: '执行中',
  [TaskTimeStatus.past]: '已结束',
};

// 监控目标
export enum MonitorTarget {
  ad = 'AD',
  creative_num = 'CREATIVE_NUM',
  creative = 'CREATIVE',
  recharge = 'RECHARGE_AMOUNT_V2',
  keyword = 'KEYWORD',
  video_creative = 'VIDEO_CREATIVE',
  creative_v2 = 'CREATIVE_V2',
  resource = 'RESOURCE',
  account_bid = 'ACCOUNT_BID',
  ctr = 'CTR',
  cvr = 'CVR',
  uniq_creative_num = 'UNIQ_CREATIVE_NUM', // 账户内非雷同创意数
}

export enum MonitorOperator {
  ge = 'GE',
  gt = 'GT',
  le = 'LE',
  lt = 'LT',
  eq = 'EQ',
  in = 'IN',
  notIn = 'NOT_IN',
  hasAny = 'HAS_ANY',
  like = 'LIKE',
  contains = 'CONTAINS',
  interval = 'INTERVAL',
  intervalContains = 'INTERVAL_CONTAINS',
}

export enum ActionExecutionStatus {
  notStart = 0,
  notComplete = 1,
  complete = 2,
}

export const MonitorTargetName = {
  [MonitorTarget.ad]: '广告数',
  [MonitorTarget.creative]: '素材数',
  [MonitorTarget.recharge]: '帐号充值',
};

export const MonitorTargetAction = {
  [MonitorTarget.ad]: {
    hide: true,
    name: '创建广告',
    urlTemplate: (v: any) => `https://ad.qq.com/atlas/${v.advertiser_id}/ad/quickly-create`,
    'data-report': 'task-action.create-ad',
  },
  [MonitorTarget.creative_num]: {
    hide: true,
    name: '创建广告',
    urlTemplate: (v: any) => `https://ad.qq.com/atlas/${v.advertiser_id}/ad/quickly-create`,
    'data-report': 'task-action.create-creative_num',
  },
  [MonitorTarget.creative]: {
    name: '新建素材',
    urlTemplate: (v: any) => `https://chuangyi.qq.com/material?uid=${v.advertiser_id}`,
    'data-report': 'task-action.create-creative',
  },
  [MonitorTarget.recharge]: {
    name: '查看充值记录',
    urlTemplate: (v: any) => `https://ad.qq.com/atlas/${v.advertiser_id}/account/record`,
    'data-report': 'task-action.charge-record',
  },
};

export const MonitorTargetTips = {
  [MonitorTarget.creative_v2]: '创意指纹id的数量，通过创意指纹算法识别，综合判定创意中图片/视频+文案的重复情况，相同或过于相似的创意会被判定为同一创意指纹id，即雷同创意。',
  [MonitorTarget.resource]: '素材指纹id的数量，通过素材指纹算法识别，综合判定创意中图片/视频的重复情况，相同或过于相似的素材会被判定为同一素材指纹id，即雷同素材。',
  [MonitorTarget.account_bid]: '账户平均出价 = 近7日账户gmv / 转化量',
  [MonitorTarget.ctr]: '账户CTR为内部计算口径，与报表数值可能不一致',
  [MonitorTarget.cvr]: '账户CVR为内部计算口径，与报表数值可能不一致',
  [MonitorTarget.uniq_creative_num]: '账户内非雷同创意：账户内相似度低的创意',
};

// 统计周期
export enum PeriodType {
  // 每日
  daily = 'DAY',
  // 周期内
  period = 'TASK',
  // 周期内日均
  periodDailyAverage = 'AVG',
}

// 动作进度
export enum ProgressStatus {
  notStarted = 0,
  lag = 1,
  unfinished = 2,
  finished = 3,
}

export const ProgressStatusName = {
  [ProgressStatus.notStarted]: '未开始',
  [ProgressStatus.lag]: '进度滞后',
  [ProgressStatus.unfinished]: '未完成',
  [ProgressStatus.finished]: '已完成',
};

export const ProgressComponentStatus = {
  [ProgressStatus.notStarted]: 'unfinished',
  [ProgressStatus.lag]: 'warning',
  [ProgressStatus.unfinished]: 'default',
  [ProgressStatus.finished]: 'success',
};

export const ProgressComponentPastStatus = {
  [ProgressStatus.notStarted]: 'unfinished',
  [ProgressStatus.lag]: 'unfinished',
  [ProgressStatus.unfinished]: 'unfinished',
  [ProgressStatus.finished]: 'success',
};

export const GiveUpReasonList = [
  '账户已停投',
  '控制基建数量',
  '控制成本',
  '任务效果太差',
  '操作时间太长难以完成',
  '任务动作太难无法完成',
  '任务动作与投放计划冲突',
  '二代运营账户，触达有限',
  '客户运营，无法干预',
  '客户周期性投放，暂时无投放需求',
  '渠道客户，无法触达',
  '其他',
];
